export interface KycBankNameMismatchRecord {
	_id?: number;
	uid?: number;
	/** Name on the KYC document. */
	fullName?: string;
	/** Name the bank holds, as validated by the payment gateway. */
	validatedAccountHolderName?: string;
	/** Last four digits of that bank account, e.g. `****7890`. Never the full number. */
	maskedAccountNumber?: string;
	documentType?: string;
	documentNumber?: string;
	status?: string;
	timestamp?: number;
	lastUpdatedAt?: number;
	manualVerificationRequired?: boolean;
	merchantName?: string;
}

export const KYC_STATUS_REJECTED = 'REJECTED';

/** One user's history is small and the API caps it at 100, so it is served as a single page. */
export const PAGE_SIZE = 100;
